export default __webpack_public_path__ + "static/media/pokemon-logo.91f65979.png";